// src/hooks/useIsMobileDevice.js
import { useEffect, useState } from "react";

/**
 * Detecta se o dispositivo é touch (celular/tablet) de verdade,
 * em vez de só olhar a largura da janela — que pode enganar em
 * janelas de desktop redimensionadas.
 *
 * Estratégia: combina "ponteiro grosso" (dedo, não mouse) com a
 * presença de pontos de toque. Reavalia se a janela for redimensionada
 * (ex.: tablet girando de retrato pra paisagem).
 */
export default function useIsMobileDevice() {
  const [isMobile, setIsMobile] = useState(() => detectar());

  useEffect(() => {
    const handler = () => setIsMobile(detectar());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return isMobile;
}

function detectar() {
  if (typeof window === "undefined") return false;

  const temPonteiroGrosso =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(pointer: coarse)").matches;

  const temToque =
    "maxTouchPoints" in navigator ? navigator.maxTouchPoints > 0 : "ontouchstart" in window;

  // Considera "mobile" apenas se tiver toque E ponteiro grosso (exclui
  // notebooks com tela touch que ainda usam majoritariamente o trackpad)
  // OU se a tela for pequena E touch (caso comum de celular).
  const telaPequena = window.innerWidth <= 820;

  return temToque && (temPonteiroGrosso || telaPequena);
}
